export default __webpack_public_path__ + "static/media/Error.7c244271.svg";